import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from './routes';

/**
 * Root component.
 *
 * Keeps two cross-cutting concerns:
 *   1. Scroll-to-top on route change so the lesson reader doesn't inherit the
 *      previous page's scroll position when a learner clicks "next lesson".
 *   2. Renders <AppRoutes /> which is the entire route table including the
 *      shared AuthedLayout shell.
 */
export default function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return <AppRoutes />;
}
